import { ContentsFileServiceApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function useDelete() {
  const queryClient = useQueryClient();
  return useAuthMutation(ContentsFileServiceApi.deleteFile, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys(KEY).all,
      });
    },
  });
}

export default useDelete;
